module.exports = __webpack_public_path__ + "static/FiestaEmpresa-33601da8044967891445cbb7a3b46cb6.jpg";